<script lang="ts">
  export let message: string;
  export let description: string | undefined = undefined;
</script>

<div class="empty-state">
  <p class="empty-state__message">{message}</p>
  {#if description}
    <p class="empty-state__description">{description}</p>
  {/if}
</div>

<style>
  .empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: var(--ptt-space-7) var(--ptt-space-5);
    gap: var(--ptt-space-2);
  }

  .empty-state__message {
    font-size: 1rem;
    font-weight: 600;
    color: var(--ptt-gray-200);
    margin: 0;
  }

  .empty-state__description {
    font-size: 0.875rem;
    color: var(--ptt-gray-100);
    margin: 0;
  }
</style>
